import ProtectedRoute from '@/components/protected-route';
import { AppAdmin } from '@/pages/AppAdmin.tsx';
import LoginPageAdmin from '@/pages/login/LoginPageAdmin.tsx';
import { ConfigProvider } from 'antd';
import { useUserContext } from 'common/context/UserContext.tsx';
import { isAuthenticated, setLoggedUserProps } from 'common/util/Util.tsx';
import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';



import 'common/pages/style.css';





const customTheme = {
  token: {
    colorPrimary: '#334D97',
    info: '#5888CF',
    colorSuccess: '#3EBB61',
    colorError: '#F6521E',

    colorBgBase: '#FFFFFF',
    colorBgContainer: '#FFFFFF',
    colorBgLayout: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBgHeader: '#0D1A43',

    colorBorder: '#CFD1D4',
    colorBorderSecondary: '#EDEDED',

    colorTextLabel: '#6F757E',
    colorTextPlaceholder: '#6F757E',
    colorTextDisabled: '#CFD1D4',

    colorFillAlter: '#F5F7FA',
    colorFillSecondary: '#D6E6FF',

    colorTextLightSolid: '#FFFFFF',

    marginLG: 24, // Gap between lines in the Form
    fontWeightStrong: 700, // Bold for the titles
  },
  components: {
    Layout: {
      siderBg: '#0D1A43',
      headerBg: '#0D1A43',
      bodyBg: '#F0F2F5',
    },
    Menu: {
      itemBg: '#0D1A43',
      itemText: '#FFFFFF',
      itemTextHover: '#0D1A43',
      itemTextSelected: '#FFA914',

      itemBgSelected: '#0D1A43',
      itemBgHover: '#0D1A43',

      colorSubBg: '#0D1A43',

      itemColor: '#FFFFFF',
      itemHoverColor: '#0D1A43',
      itemSelectedColor: '#FFA914',
      itemSelectedBg: '#0D1A43',
      itemSelectedTextColor: '#FFA914',
    },
    Breadcrumb: {
      itemColor: '#FFFFFF',
      linkColor: '#FFFFFF',
      separatorColor: '#FFFFFF',
      lastItemColor: '#FFFFFF',
    },
    Table: {
      headerBg: '#FFFFFF',
      headerColor: '#0F1928',
      rowHoverBg: '#F5F7FA',
      rowSelectedBg: 'transparent',
      borderColor: '#CFD1D4',
      sortIconColor: '#5888CF',
      bodySortBg: '#FFFFFF',
      headerSortActiveBg: '#FFFFFF',
      fixedHeaderSortActiveBg: '#FFFFFF',
    },
    Button: {
      colorPrimary: '#334D97',
      colorPrimaryHover: '#5888CF',
      colorTextLightSolid: '#FFFFFF',
      colorBorder: '#EDEDED',
      defaultBg: '#FFFFFF',
      defaultColor: '#0F1928',
      defaultBorderColor: '#CFD1D4',
    },
    Input: {
      colorTextPlaceholder: '#6F757E',
      colorBorder: '#CFD1D4',
      activeBorderColor: '#334D97',
    },
    Select: {
      colorTextPlaceholder: '#6F757E',
      optionSelectedBg: '#D6E6FF',
    },
    Tag: {
      defaultBg: '#F5F7FA',
      defaultColor: '#0F1928',
    },
    DatePicker: {
      cellActiveWithRangeBg: '#CFD1D4',
      cellHoverWithRangeBg: '#CFD1D4',
      cellRangeBorderColor: '#CFD1D4',
    },
    Form: {
      itemMarginBottom: 16,
    },
    Switch: {
      trackMinWidthSM: 32,
    },
    Card: {
      headerFontSize: 20,
      headerFontWeight: 700,
    },
  },
}

const MainAdmin = () => {
  const { setUser } = useUserContext()

  useEffect(() => {
    if (isAuthenticated()) {
      setLoggedUserProps(setUser)
    }
  }, [])

  return (
    <ConfigProvider theme={customTheme}>
      <Routes>
        <Route path="/login" element={<LoginPageAdmin />} />
        <Route path="/*" element={<ProtectedRoute />}>
          <Route path="*" element={<AppAdmin />} />
        </Route>
      </Routes>
    </ConfigProvider>
  )
}

export default MainAdmin
